<template>
  <Box class="versionDatetime">
    <div class="versionDatetime__header">
      <div>
        <p class="versionDatetime__title">
          Vis data pr.
        </p>
      </div>
      <Datejump v-model="selectedDate" />
    </div>

    <BaseDatetimePicker
      v-model="selectedDate"
      class="versionDatetime__section"
    />

    <select
      class="base-input"
      v-model="meta.selectedVersion"
      @change="onSelectVersion"
    >
      <option
        value=""
        disabled
        selected
      >
        Vælg version
      </option>
      <option
        v-for="version in meta.versions"
        :key="version.versionNumber"
        :value="version"
      >
        {{ customLabel(version) }}
      </option>
    </select>
  </Box>
</template>

<script>
import Datejump from './Datejump.vue';
import Box from './Box.vue';
import BaseDatetimePicker from './BaseDatetimePicker.vue';
import HumanDate from '../filters/HumanDate';

export default {
    name: 'VersionDatetimePicker',
    components: {
        BaseDatetimePicker, Box, Datejump,
    },
    props: {
        meta: { type: Object, required: true },
        item: { type: Object, required: true },
    },
    data() {
        return {
            loading: false,
        };
    },
    computed: {
        selectedDate: {
            get() {
                return window.moment(this.meta.selectedDate).toISOString();
            },
            set(value) {
                this.$set(this.meta, 'selectedDate', value);
            },
        },
        isBeforeFirstVersion() {
            return !!window.moment(this.meta.selectedDate).isBefore(this.meta.versions[this.meta.versions.length - 1].publishDate);
        },
    },
    methods: {
        customLabel({ versionNumber, publishDate }) {
            return `Version ${versionNumber} - ${HumanDate(publishDate)}`;
        },
        onSelectVersion() {
            this.meta.selectedDate = this.meta.selectedVersion.publishDate;
        },
    },
};
</script>

<style lang="scss" scoped>
.versionDatetime {
    width: 100%;
    padding: 30px;
    margin-bottom: 25px;

    &__header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-direction: column;
    }

    &__section {
        padding-top: 5px;
        padding-bottom: 10px;
    }

    &__picker {
        display: flex;
        align-items: center;
        justify-content: space-between;
        &:not(:last-child) {
            margin-bottom: 10px;
        }
    }

    &__title {
        font-size: 12px;
        margin-bottom: 10px;
    }
}
</style>
